module.exports = __webpack_public_path__ + "img/hk_room_floorplan_09_en.27b81e93.png";